module.exports = __webpack_public_path__ + "static/media/triggered-icon.8953822e.svg";